export default {"src":"/_next/static/media/safety.606e95c2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};